import React, { useState } from 'react';
import { Search, SlidersHorizontal, X, ChevronDown } from 'lucide-react';
import Header from './components/Header2';
import Footer from './components/Footer2';
import ProductCard from './components/ProductCard';
import Button from './components/Button';

const Shop = () => {
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [showFilters, setShowFilters] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const categories = ['All', 'Sarees', 'Lehengas', 'Kurtas', 'Bridal Wear', 'Fusion Wear'];
    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Royal Banarasi Saree', category: 'Sarees', price: 12999, badge: 'NEW', image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Silk Embroidered Lehenga', category: 'Lehengas', price: 24500, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Designer Anarkali Kurta', category: 'Kurtas', price: 8999, badge: 'TRENDING', image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Zardozi Bridal Set', category: 'Bridal Wear', price: 35000, image: 'https://images.pexels.com/photos/6712360/pexels-photo-6712360.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Chanderi Cotton Kurta', category: 'Kurtas', price: 4999, badge: 'NEW', image: 'https://images.pexels.com/photos/7275385/pexels-photo-7275385.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Pashmina Shawl Collection', category: 'Fusion Wear', price: 6500, image: 'https://images.pexels.com/photos/8953474/pexels-photo-8953474.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Kanjivaram Silk Saree', category: 'Sarees', price: 18999, badge: 'BESTSELLER', image: 'https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Indo-Western Fusion Gown', category: 'Fusion Wear', price: 15499, image: 'https://images.pexels.com/photos/3819793/pexels-photo-3819793.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Organza Floral Saree', category: 'Sarees', price: 9999, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 10, name: 'Embroidered Palazzo Set', category: 'Kurtas', price: 7499, image: 'https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 11, name: 'Velvet Bridal Lehenga', category: 'Bridal Wear', price: 45000, badge: 'PREMIUM', image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 12, name: 'Cotton Printed Kurta', category: 'Kurtas', price: 2999, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = products
        .filter(p => selectedCategory === 'All' || p.category === selectedCategory)
        .filter(p => !searchQuery || p.name.toLowerCase().includes(searchQuery.toLowerCase()))
        .sort((a, b) => {
            if (sortBy === 'price-low') return a.price - b.price;
            if (sortBy === 'price-high') return b.price - a.price;
            return 0;
        });

    return (
        <div className="w-full min-h-screen bg-[#0A0A0A]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap" rel="stylesheet" />
            <Header />

            <main className="pt-[90px] md:pt-[110px] pb-16">
                {/* Hero Banner */}
                <div className="px-4 md:px-6 pb-8 md:pb-12 text-center border-b border-[#2A2A2A]">
                    <div className="max-w-[800px] mx-auto">
                        <p className="text-xs font-medium tracking-[0.3em] uppercase mb-3 text-[#FF6B35] font-['Montserrat']">
                            Curated for you
                        </p>
                        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold uppercase tracking-wider mb-3 text-white font-['Montserrat']">
                            Our Collection
                        </h1>
                        <p className="text-sm md:text-base text-[#A3A3A3] font-['Montserrat'] font-light">
                            Discover handcrafted Indian fashion that celebrates bold colours and timeless elegance
                        </p>
                    </div>
                </div>

                {/* Search & Filter Bar */}
                <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-6 md:pt-10">
                    {/* Search */}
                    <div className="relative mb-6">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#525252]" />
                        <input
                            type="text"
                            placeholder="Search products..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="w-full pl-10 pr-4 py-3 text-sm bg-[#1A1A1A] border border-[#2A2A2A] text-white placeholder-[#525252] focus:outline-none focus:border-[#FF6B35] transition-colors font-['Montserrat']"
                        />
                    </div>

                    {/* Categories & Sort */}
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                        {/* Category Pills */}
                        <div className="flex overflow-x-auto gap-2 pb-2 md:pb-0 scrollbar-hide">
                            {categories.map((cat) => (
                                <button
                                    key={cat}
                                    onClick={() => setSelectedCategory(cat)}
                                    className={`flex-shrink-0 px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-all duration-300 font-['Montserrat'] ${
                                        selectedCategory === cat
                                            ? 'bg-[#FF6B35] text-white border border-[#FF6B35]'
                                            : 'bg-transparent text-[#A3A3A3] border border-[#2A2A2A] hover:border-[#FF6B35] hover:text-[#FF6B35]'
                                    }`}
                                >
                                    {cat}
                                </button>
                            ))}
                        </div>

                        {/* Sort */}
                        <div className="relative">
                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                className="appearance-none px-4 py-2.5 pr-10 text-xs font-medium bg-[#1A1A1A] border border-[#2A2A2A] text-[#A3A3A3] focus:outline-none focus:border-[#FF6B35] transition-colors font-['Montserrat'] uppercase tracking-wider cursor-pointer"
                            >
                                {sortOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#525252] pointer-events-none" />
                        </div>
                    </div>

                    {/* Results Count */}
                    <p className="text-xs text-[#525252] mb-6 font-['Montserrat']">
                        Showing {filteredProducts.length} product{filteredProducts.length !== 1 ? 's' : ''}
                    </p>

                    {/* Product Grid */}
                    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-4 lg:gap-6">
                        {filteredProducts.map((product) => (
                            <ProductCard key={product.id} product={product} />
                        ))}
                    </div>

                    {filteredProducts.length === 0 && (
                        <div className="text-center py-20">
                            <p className="text-lg text-[#A3A3A3] font-['Montserrat'] mb-4">No products found</p>
                            <Button variant="secondary" onClick={() => { setSelectedCategory('All'); setSearchQuery(''); }}>
                                Clear Filters
                            </Button>
                        </div>
                    )}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Shop;
